export function getOrigin() {
  if (isSSR()) {
    return window.location.origin;
  } else {
    return '/';
  }
}

export function isSSR(){
  try {
      localStorage.setItem("test", "test");
      localStorage.removeItem("test");
      return true;
  } catch(e) {
      return false;
  }
}